export default "__VITE_ASSET__BiZ9FKXU__ 1920w";